import { useTheme } from '@mui/material';
import { ReactComponent as KlydoIcon } from '../../../design-system/Icons/KlydoIcon.svg';
import DSBox from '../../../design-system/DSBox';
import { DSTypography } from '../../../design-system/Typography';
import DSPrimaryButton from '../../../design-system/DSPrimaryButton';
import DSSecondaryButton from '../../../design-system/DSSecondaryButton';
import DSCircularProgress from '../../../design-system/DSCircularProgress';
import { KLYDO_YELLOW } from '../../../consts/colors';
import ConnectClockModal from '../../Klydos/components/ConnectClockModal';
import WarningDialog from '../../../components/WarningDialog';
import useMyClock from '../hooks/useMyClock';

const MyClockCard = () => {
  const { spacing } = useTheme();
  const {
    isConnected,
    clockName,
    isLoadingClockData,
    isConnectModalOpen,
    openConnectModal,
    closeConnectModal,
    isDisconnectDialogOpen,
    openDisconnectDialog,
    closeDisconnectDialog,
    handleConnect,
    handleDisconnect,
    isConnecting,
    isDisconnecting,
  } = useMyClock();

  return (
    <DSBox sx={{ pb: spacing(3) }}>
      <DSBox
        sx={{
          backgroundColor: 'secondary.dark',
          borderRadius: '16px',
          padding: { xxs: '30px 8px', sm: '33px' },
        }}
      >
        <DSBox
          sx={{
            display: 'flex',
            flexDirection: { xxs: 'column', sm: 'row' },
            alignItems: { xxs: 'flex-start', sm: 'center' },
            justifyContent: 'space-between',
            gap: spacing(2),
            width: '100%',
          }}
        >
          <DSBox
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '20px',
            }}
          >
            <DSBox
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '48px',
                height: '48px',
                borderRadius: '14px',
                backgroundColor: 'paper.elevation5',
                flexShrink: 0,
              }}
            >
              <KlydoIcon width={24} height={24} />
            </DSBox>
            <DSBox
              sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}
            >
              <DSTypography variant="h5" color="common.white">
                My Clock
              </DSTypography>
              {isConnected ? (
                <DSTypography
                  variant="body2"
                  sx={{
                    fontFamily: 'Gilroy-Bold',
                    color: KLYDO_YELLOW,
                  }}
                >
                  {clockName ||
                    (isLoadingClockData ? 'Loading…' : 'Klydoclock')}
                </DSTypography>
              ) : (
                <DSTypography variant="body2" color="text.secondary">
                  Connect a Klydoclock to preview your klydos on the real device
                </DSTypography>
              )}
            </DSBox>
          </DSBox>
          {isConnected ? (
            <DSSecondaryButton
              onClick={openDisconnectDialog}
              disabled={isDisconnecting}
              sx={{ color: 'error.main', flexShrink: 0 }}
            >
              {isDisconnecting ? (
                <DSCircularProgress size={20} />
              ) : (
                'Disconnect'
              )}
            </DSSecondaryButton>
          ) : (
            <DSPrimaryButton onClick={openConnectModal} sx={{ flexShrink: 0 }}>
              Connect
            </DSPrimaryButton>
          )}
        </DSBox>
      </DSBox>

      <ConnectClockModal
        open={isConnectModalOpen}
        onClose={closeConnectModal}
        onConnect={handleConnect}
        isLoading={isConnecting}
      />

      <WarningDialog
        open={isDisconnectDialogOpen}
        warningMessage={`Disconnect ${clockName || 'this clock'}?\nYou can reconnect it anytime with its serial number.`}
        handleConfirmationClick={handleDisconnect}
        handleClose={closeDisconnectDialog}
        isConfirmDisabled={isDisconnecting}
      />
    </DSBox>
  );
};

export default MyClockCard;
